var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"inner-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('swap_chain_title')))]),_c('SwapDetailsWithChat',{attrs:{"proposition-id-b-part":Number(_vm.params.propositionIdBPart),"proposition-id-c-part":Number(_vm.params.propositionIdCPart)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }